import { api } from './client.js';

export type MessageSource = 'external' | 'carrefour';

export interface Message {
  messageId: string;
  title: string;
  body: string;
  source: MessageSource;
  url: string | null;
  read: boolean;
  createdAt: string;
}

export interface MessagePage {
  items: Message[];
  cursor: string | null;
  unread: number;
}

export async function listMessages(cursor?: string | null): Promise<MessagePage> {
  const qs = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
  return api<MessagePage>(`/messages${qs}`);
}

export async function getMessage(messageId: string): Promise<Message> {
  const r = await api<{ message: Message }>(`/messages/${messageId}`);
  return r.message;
}

export async function setMessageRead(messageId: string, read: boolean): Promise<Message> {
  const r = await api<{ message: Message }>(`/messages/${messageId}`, {
    method: 'PATCH',
    body: JSON.stringify({ read }),
  });
  return r.message;
}

export async function markAllMessagesRead(): Promise<number> {
  const r = await api<{ updated: number }>('/messages/read-all', { method: 'POST' });
  return r.updated;
}

export async function deleteMessage(messageId: string): Promise<void> {
  await api<void>(`/messages/${messageId}`, { method: 'DELETE' });
}
